// Module Imports
import { useEffect, useState } from "react"
import { useIdleTimer } from "react-idle-timer"

// MUI Component Imports
import {
  Box,
  Button,
  IconButton,
  Toolbar,
  Typography,
  Menu,
  MenuItem,
} from "@mui/material"

// Style Imports
import { AppBar } from "./Atom"

// MUI Icon Imports
import MenuIcon from "@mui/icons-material/Menu"
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp"
import AccountCircleIcon from "@mui/icons-material/AccountCircle"

// Icon Imports
import CalendarIcon from "../../../assets/icons/calendar.svg"
import ProntoLogoIcon from "../../../assets/icons/prontoIcon.png"

// Utility imports
import {
  dateFormatter,
  firstCap,
  secondsToFancyTime,
} from "../../../helper/utils"

// type Props = {}

const NavAppBar = (props: any) => {
  const {
    open,
    handleDrawerOpen,
    adminData,
    handleClick,
    handleClose,
    handleClickMyAccount,
    handleLogout,
    anchorEl,
    opener,
  } = props

  const formattedDate = dateFormatter()

  //? Code for Showing Remaining idle timeout

  // const [remaining, setRemaining] = useState<string>("")

  // const { getRemainingTime } = useIdleTimer({
  //   timeout: 1200000,
  //   throttle: 0,
  // })

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     const duration = getRemainingTime() / 1000
  //     let time = secondsToFancyTime(duration)
  //     setRemaining(time)
  //   }, 500)

  //   return () => {
  //     clearInterval(interval)
  //   }
  // })

  return (
    <AppBar position="fixed" open={open}>
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          sx={{
            marginRight: 5,
            ...(open && { display: "none" }),
            "&:hover": { backgroundColor: "none" },
          }}
          disableRipple={true}
        >
          {/* <ProntoLogoIcon /> */}
          <img height={"25px"} src={ProntoLogoIcon} alt="" />
        </IconButton>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerOpen}
          edge="start"
          sx={{
            marginLeft: "-21px",
            marginRight: 5,
            ...(open && { display: "none" }),
          }}
        >
          <MenuIcon />
        </IconButton>
        <Typography
          variant="h6"
          component="div"
          sx={{ flexGrow: 1, fontSize: "14px" }}
          textTransform={"capitalize"}
        >
          {adminData?.admin?.data?.role_id === undefined
            ? ""
            : adminData?.admin?.data?.role_display_name}
        </Typography>
        {
          //? Showing remaining idle timer
          //   <Typography sx={{ marginRight: "14px" }}>
          //   You will be logged out in {remaining} for being idle.
          // </Typography>
        }
        <img src={CalendarIcon} style={{ marginRight: "14px" }} />
        <Box sx={{ marginRight: "55px", fontSize: "12px" }}>
          {formattedDate}
        </Box>
        {/* <img src={NotificationBell} style={{ marginRight: "25px" }} /> */}
        <Button
          variant="outlined"
          color="inherit"
          sx={{
            // width: "220px",
            height: "7vh",
            display: "flex",
            justifyContent: "space-between",
            border: "1px solid #EEEEEE",
            borderRadius: "4px",
            alignItems: "center",
            padding: "0 12px !important",
          }}
          id="basic-button"
          aria-controls={opener ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={opener ? "true" : undefined}
          onClick={handleClick}
          style={{ textTransform: "none" }}
        >
          {/* <Avatar
            src={UserImg}
            sx={{ height: "32px", width: "32px" }}
            variant="square"
          /> */}
          <AccountCircleIcon
            sx={{
              padding: "0",
              marginRight: "10px",
              fontSize: "24px",
              // border: "1px solid red"
            }}
          />
          <Typography fontSize={14}>
            {adminData?.admin?.data?.first_name &&
            adminData?.admin?.data?.first_name
              ? `${adminData?.admin?.data?.first_name} ${adminData?.admin?.data?.last_name}`
              : ``}
          </Typography>
          {opener ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </Button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={opener}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
          // sx={{ width: "fit-content" }}
        >
          {/* <MenuItem onClick={handleClose}>Profile</MenuItem> */}
          <MenuItem
            sx={{ fontSize: "14px", width: "200px" }}
            onClick={() => handleClickMyAccount()}
          >
            My Account
          </MenuItem>
          <MenuItem
            sx={{ fontSize: "14px", width: "200px" }}
            onClick={handleLogout}
          >
            Logout
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  )
}

export default NavAppBar
